import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode:'dark',
    primary: {
      main:'#181818' , 
    },
  },
});

export default theme;
